import Footer from '@/components/Layout/Footer/Footer';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import './st.css';
import card2 from '@/assets/card2.png';
import card4 from '@/assets/card4.png';
import card5 from '@/assets/card5.png';
import appleIcon from '@/assets/apple-pay.png';
import payPal from '@/assets/paypal.png';
import card6 from '@/assets/escrow.png';
import 'react-responsive-modal/styles.css';
import UserHeadBar from '../components/UserHeadBar';
import PayPalButton from '@/components/Payments/Paypal/PayPalButton';
import { paypal } from '@/api/paypal/paypal';
import BackdropLoader from '@/components/Elements/Loader/BackdropLoader';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import { FeatureAd } from '@/api/feature/addFeature';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import ChargeForm from '@/components/Payments/StripeCharge/ChargeForm';
import ChargeInvestCom from '@/components/Payments/StripeCharge/ChargeInvestCom';
import storage from '@/utils/storage';
import { formatPrice } from '@/utils/format';

export const PayForInvestCom = () => {
  const key = process.env.REACT_APP_STRIPE_KEY as string;

  const { idSub } = useParams();
  const [queryParams] = useSearchParams();
  const price: string | null = queryParams.get('price');
  const discount: string | null = queryParams.get('discount');
  const type: string | null = queryParams.get('type');
  const stripePromise = loadStripe(`${key}`);
  const localSymbol = storage.getSymbol();
  const localCurrency = storage.getAmount();

  const propType: string | null = queryParams.get('propType');
  const propId: string | null = queryParams.get('propId');

  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [paypalData, setPaypalData] = useState('');

  const percentageOff = (price: number, percentageValue: number): number => {
    return price * (1 - percentageValue / 100);
  };

  const netPrice = percentageOff(parseInt(price), discount);

  const finalAmount = netPrice.toString().split('.');
  console.log(propType);

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      console.log(propType);
      let payload;
      if (propType !== null) {
        payload = {
          property_type: propType,
          property_id: propId,
          plan_id: idSub,
          price: finalAmount[0],
        };
      } else {
        payload = {
          subscription_id: idSub,
          price: finalAmount[0],
        };
      }
      console.log(payload);

      const data = await paypal(payload);
      setPaypalData(data?.payment_url);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (paypalData != '') {
      window.open(paypalData);
    }
  }, [paypalData]);

  return (
    <>
      <BackdropLoader open={isLoading} />

      <UserHeadBar />
      {/* <button onClick={() => navigate(-1)}>
        <i className="fa-regular fa-circle-left go-back-button"></i>
      </button> */}
      <section className="container pays my-5">
        <div className="payment-Methods">
          <div className="row">
            <h3 className="pts">
              Pay Amount of {localSymbol} {formatPrice(price * localCurrency)} Through Stripe
            </h3>
            <div className="col-8 mx-auto">
              {/* <h3 className="mb-3 mb-xxl-4">Select Payment Method</h3> */}
              {/* <h3 className="mb-3 mb-xxl-4">Pay Using Stripe</h3> */}
              <div className="d-flex justify-content-center">
                <div className="d-flex align-items-start flex-column ">
                  <FormControl className="mt-5">
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label border-0"
                      defaultValue="stripe"
                      name="radio-buttons-group"
                    >
                      <div
                        role="button"
                        className="outer-card"
                      // onClick={() =>
                      //   navigate(
                      //     `/user/subscription-payment/${idSub}?price=${price}&discount=${discount}&propType=${propType}&propId=${propId}`
                      //   )
                      // }
                      >
                        <div className="card-box d-flex gap-2 align-items-center border-0">
                          <FormControlLabel
                            className="mb-0 pb-0"
                            value="stripe"
                            control={<Radio />}
                            label="Pay Using Stripe"
                          />
                          <img src={card5} alt="CARDStripe" />
                        </div>
                      </div>
                      {/* <div role="button" className="outer-card" onClick={() => handleSubmit()}>
                  <div className="card-box d-flex gap-2 align-items-center border-0">
                    <FormControlLabel
                      className="mb-0 pb-0"
                      value="paypal"
                      control={<Radio />}
                      label="Pay Using PayPal"
                    />
                    <img src={card2} alt="CARDStripe" />
                  </div>
                </div> */}
                    </RadioGroup>
                  </FormControl>
                  <FormControl className="mt-2">
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label border-0"
                      defaultValue="stripe"
                      name="radio-buttons-group"
                    >
                      <div
                        role="button"
                        className="outer-card"
                      // onClick={() =>
                      //   navigate(
                      //     `/user/subscription-payment/${idSub}?price=${price}&discount=${discount}&propType=${propType}&propId=${propId}`
                      //   )
                      // }
                      >
                        <div className="card-box d-flex gap-2 align-items-center border-0">
                          <FormControlLabel
                            className="mb-0 pb-0"
                            // value="stripe"
                            control={<Radio />}
                            label="Pay Using Apple Pay"
                          />
                          <img
                            src={appleIcon}
                            alt="CARDStripe"
                            className="img-fluid"
                            width={50}
                            height={50}
                          />
                        </div>
                      </div>
                      {/* <div role="button" className="outer-card" onClick={() => handleSubmit()}>
                  <div className="card-box d-flex gap-2 align-items-center border-0">
                    <FormControlLabel
                      className="mb-0 pb-0"
                      value="paypal"
                      control={<Radio />}
                      label="Pay Using PayPal"
                    />
                    <img src={card2} alt="CARDStripe" />
                  </div>
                </div> */}
                    </RadioGroup>
                  </FormControl>
                  <FormControl className="mt-2">
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label border-0"
                      defaultValue="stripe"
                      name="radio-buttons-group"
                    >
                      <div
                        role="button"
                        className="outer-card"
                      // onClick={() =>
                      //   navigate(
                      //     `/user/subscription-payment/${idSub}?price=${price}&discount=${discount}&propType=${propType}&propId=${propId}`
                      //   )
                      // }
                      >
                        <div className="card-box d-flex gap-2 align-items-center border-0">
                          <FormControlLabel
                            className="mb-0 pb-0"
                            // value="stripe"
                            control={<Radio />}
                            label="Pay Using Paypal "
                          />
                          <img
                            src={payPal}
                            alt="CARDStripe"
                            className="img-fluid"
                            width={50}
                            height={50}
                          />
                        </div>
                      </div>
                      {/* <div role="button" className="outer-card" onClick={() => handleSubmit()}>
                  <div className="card-box d-flex gap-2 align-items-center border-0">
                    <FormControlLabel
                      className="mb-0 pb-0"
                      value="paypal"
                      control={<Radio />}
                      label="Pay Using PayPal"
                    />
                    <img src={card2} alt="CARDStripe" />
                  </div>
                </div> */}
                    </RadioGroup>
                  </FormControl>
                </div>

                {/* <div className="col-md-3 col-4 outer-card">
              <div className="card-box">
                <img src={card4} alt="CARD" />
              </div>
            </div> */}
                {/* <div className="col-md-3 col-4 outer-card">
              <div className="card-box">
                <img src={card6} alt="CARD" />
              </div>
            </div> */}

                <Elements stripe={stripePromise}>
                  <ChargeInvestCom
                    price={price}
                    discount={discount}
                    propType={propType}
                    propId={propId}
                    formId={idSub}
                    type={type}
                  />
                </Elements>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};
